export default __webpack_public_path__ + "static/media/CTP_Light_PT.fc9453e1.svg";